define("ROOM4.CCAProductGallery.CCAProductGallery.HeaderGalleryButton.View", [
  "room4_ccaproductgallery_header_gallery_button.tpl",
  "Backbone",
], function (room4_ccaproductgallery_header_gallery_button_tpl, Backbone) {
  "use strict";

  return Backbone.View.extend({
    template: room4_ccaproductgallery_header_gallery_button_tpl,

    initialize: function initialize(options) {
      this.container = options.container;
    },

    getContext: function getContext() {
      return {};
    },
  });
});
